module.exports = __webpack_public_path__ + "static/media/kalam-regular-webfont.806d60a7.woff";